import React, { JSX } from 'react';
import { LayoutContainer, PageSection, PageSectionContent } from '@greystar/designsystem';
import { PropertyDetailsFeesProps, PropertyFees } from '@greystar/ui';
import { Property, GetLevelsResponse } from '@greystar/lib';
import { GetStaticComponentProps, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

const PropertyDetailsFees = (props: PropertyDetailsFeesProps): JSX.Element => {
  if (!props.data || props.data.notFound || !props.data?.fees) {
    return <></>;
  }

  const isCalculatorPage =
    props?.params?.showCalculatorDescription && props?.params?.showCalculatorDescription === '1';

  const pricingAndCostsDescription =
    props.data.overridePricingAndCostsText ?? props?.fields?.pricingAndCostsText ?? null;

  const pricingAndCostsTitle =
    props.data.overridePricingAndCostsHeader?.value ??
    props?.fields?.pricingAndCostsHeader?.value ??
    '';

  return (
    <PageSection topColour="beige" id="fee-table" style={{ overflow: 'visible' }}>
      <PageSectionContent>
        <PageSectionContent className="pt-4 md:pt-[12px] lg:pt-0 max-w-[61rem] mx-0">
          <LayoutContainer flexDirection="column" gap="lg">
            <PropertyFees
              title={isCalculatorPage ? null : props.fields.title}
              policiesTitle={isCalculatorPage ? null : props.fields.policiesTitle}
              policiesDescription={isCalculatorPage ? null : props.data.policies}
              disclosuresAndLicensesTitle={
                isCalculatorPage ? null : props.fields.disclosuresAndLicensesTitle
              }
              disclosuresAndLicensesDescription={
                isCalculatorPage ? null : props.data.disclosuresLicenses
              }
              pricingAndCostsTitle={pricingAndCostsTitle}
              pricingAndCostsDescription={pricingAndCostsDescription}
              fees={props.data?.fees ?? []}
              tabConfiguration={props?.fields.tabConfiguration}
              propertyId={props.data?.propertyId ?? ''}
              propertyName={props.data?.propertyName ?? ''}
              propertyLocation={props.data?.propertyLocation}
            />
          </LayoutContainer>
        </PageSectionContent>
      </PageSectionContent>
    </PageSection>
  );
};

export const getStaticProps: GetStaticComponentProps = async (
  _rendering,
  layoutData
): Promise<PropertyDetailsFeesProps> => {
  const props = _rendering as unknown as PropertyDetailsFeesProps;
  const property = layoutData.sitecore.context.property as Property;

  const response: PropertyDetailsFeesProps = {
    ...props,
    data: {
      notFound: true,
      fees: null,
      propertyId: null,
      propertyName: null,
      propertyLocation: null,
      overridePricingAndCostsHeader: null,
      overridePricingAndCostsText: null,
      disclosuresLicenses: null,
      policies: null,
    },
  };

  if (!property) {
    return response;
  }

  const locationsData = layoutData.sitecore.context.locationsData as GetLevelsResponse;

  if (locationsData?.search?.results?.length && property?.location?.state) {
    const stateData = locationsData.search.results.find(
      (result) =>
        result.name && result.name.toLowerCase() === property.location?.state?.toLowerCase()
    );

    if (stateData) {
      return {
        ...response,
        data: {
          ...response.data,
          notFound: false,
          fees: property.fees ?? null,
          propertyName: property.name ?? null,
          propertyLocation: property.location ?? null,
          disclosuresLicenses: property.about?.disclosuresLicenses ?? null,
          policies: property.about?.policies ?? null,
          overridePricingAndCostsHeader:
            stateData.pricingAndCostsHeader && stateData.pricingAndCostsHeader.value !== ''
              ? stateData.pricingAndCostsHeader
              : null,
          overridePricingAndCostsText:
            stateData.pricingAndCostsText && stateData.pricingAndCostsText.value !== ''
              ? stateData.pricingAndCostsText
              : null,
        },
      };
    }
  }

  return {
    ...response,
    data: {
      ...response.data,
      notFound: false,
      fees: property.fees ?? null,
      propertyName: property.name ?? null,
      propertyLocation: property.location ?? null,
      disclosuresLicenses: property.about?.disclosuresLicenses ?? null,
      policies: property.about?.policies ?? null,
    },
  };
};

export default withDatasourceCheck()<PropertyDetailsFeesProps>(PropertyDetailsFees);
